import { UserGroupDto } from 'src/app/core/models/user-group-model';
import { GroupResponseModel, UserResponseModel } from '../services/iamapi/iamapi.services';

export class GetUserGroupsTransform {
  static transformOutput(allGroups: GroupResponseModel[], userGroups: UserResponseModel): UserGroupDto {
    const assignedGroupIds = userGroups.groups?.map(group => group.userGroupId) || [];

    const groupSet: Record<number, any> = {};
    allGroups.forEach(
      group =>
        (groupSet[group.groupId] = {
          groupId: group.groupId,
          groupCode: group.groupCode,
          groupDescription: group.groupDescription,
          isAssigned: false,
        }),
    );

    // Mark assigned groups
    assignedGroupIds.forEach(groupId => {
      const group = groupSet[groupId];
      if (group !== null && group !== undefined) {
        group.isAssigned = true;
        group.effectiveDate = userGroups.groups?.find(g => g.userGroupId === groupId)?.effectiveDate;
      }
    });

    const groupsData = Object.values(groupSet);

    return {
      assignedGroups: groupsData.filter(group => group.isAssigned),
      availableGroups: groupsData.filter(group => !group.isAssigned),
    };
  }
}
